import AnnualTrend from "../../AnnualTrend.js";
import KeyFigureResult from "../../../keyFigure/KeyFigureResult.js";
import Model from "../../../Model.js";
import Report from "./Report.js";

/**
 * `periodReportData` represent a period report's calculated components.
 *
 * @param {KeyFigureResult} spec.keyFigureResult - KeyFigure result for the report
 * @param {report} spec.incomeStatement - Income statement report of the period report
 * @param {report} spec.balanceSheet - Income statement report of the period report
 * @param {annualTrend} spec.overviewData - AnnualTrend data of the period report
 */
export default class PeriodReportData extends Model {
	constructor({
		keyFigureResult,
		incomeStatement,
		overviewData,
		balanceSheet,
	}) {
		super(...arguments);

		this._keyFigureResult = keyFigureResult;
		this._incomeStatement = incomeStatement;
		this._overviewData = overviewData;
		this._balanceSheet = balanceSheet;
	}

	getKeyFigureResult() {
		return this._keyFigureResult;
	}

	getOverviewData() {
		return this._overviewData;
	}

	getBalanceSheet() {
		return this._balanceSheet;
	}

	getIncomeStatement() {
		return this._incomeStatement;
	}

	getKeyFigureValues() {
		return this.getKeyFigureResult().getValues();
	}

	static transformMaterializationData(data, context) {
		const period = context.findPeriodById(data.periodString);
		data.period = period;

		data.keyFigureResult = KeyFigureResult.materialize(
			{
				values: data.keyFigureValues,
				keyFigureIds: data.keyFigureIds,
				periodIds: [data.periodString],
				periodType: period.getPeriodType(),
			},
			context,
		);

		data.overviewData = new AnnualTrend(data.annualTrend);

		data.incomeStatement = Report.materialize(
			data.condensedIncomeStatement,
			context,
		);

		data.balanceSheet = Report.materialize(
			data.condensedBalanceSheet,
			context,
		);
	}
}
